import { useEffect, useRef } from 'react'

function useTimeout(callback, delay) {
    const savedCallback = useRef()

    // Remember the latest callback.
    useEffect(
        () => {
            savedCallback.current = callback
        },
        [callback]
    )

    // Set up the interval.
    useEffect(
        () => {
            function tick() {
                savedCallback.current()
            }
            if (delay !== null) {
                const id = setTimeout(tick, delay)
                return () => clearTimeout(id)
            }
        },
        [delay]
    )
}

function timeout(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
}
export {timeout}
export default useTimeout